<template>
  <div class = "groupWebsiteList">
    <el-card>
      <el-button type="primary" slot="header" @click="add">{{$t('lang.btn_addGroupNews')}}</el-button>
      <el-table
        :data="tableData"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        class="wid100"
        :row-class-name="tableRowClassName"
      >
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
        <el-table-column
          prop="newsTitle"
          :label="$t('lang.lab_titleGroupNews')">
        </el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('lang.lab_createTime')"
          sortable>
          <template slot-scope="scope">
            {{ scope.row.createTime | time }}
          </template>
        </el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right" :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:groupWebsiteList
 *@Description:集团网站维护
 *@author:杜斌
 *@Copyright:格众科技
 *@date:2021-08-11
 */
// import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      tableData: [], // 新闻list
      pageNo: 1, // 页数
      pageSize: 10, // 每页显示数量
      pageCount: 0, // 总页数
    }
  },
  created() {
    setTimeout(() => {
      window.localStorage.setItem('jtxwform', '')
      window.localStorage.setItem('jtxwsaveData', '')
    }, 200)
    this.getData()
  },
  watch: {

  },
  methods: {
    // 获取列表数据
    getData() {
      let loading = this.$loading()
      this.$get(`/groupNewsList?pageNo=${this.pageNo}&pageSize=${this.pageSize}`).then(
        res => {
          loading.close()
          console.log(res)
          if (res && res.err === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        }, 
        error => {
          loading.close()
          this.$message.error(error)
        })
    },
    // 新增新闻
    add() {
      window.localStorage.setItem('jtxwform', '')
      window.localStorage.setItem('jtxwsaveData', '')
      this.$router.push({ name: 'groupWebsiteAdd', query: { flag: false } })
    },
    // 编辑新闻
    edit(rowData) {
      window.localStorage.setItem('jtxwform', '')
      window.localStorage.setItem('jtxwsaveData', '')
      this.$router.push({ name: 'groupWebsiteEdit',
      query: {
        flag: true,
        object: rowData }
        })
    },
    // 删除新闻
    deleteOne(id) {
      let loading = this.$loading()
      this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
        confirmButtonText: this.$i18n.t('lang.btn_confirm'),
        cancelButtonText: this.$i18n.t('lang.btn_cancel'),
        type: 'warning'
      }).then(() => {
          this.$delete(`/groupNewsDel/` + id).then(
            res => {
              loading.close()
              console.log(res)
              if (res && res.err === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.commit()
              } else {
                loading.close()
                this.$message.error('删除失败')
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    },
    // 更新
    commit() {
      this.pageNo = 1
      this.getData()
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getData()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getData()
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
  }
}
</script>

<style lang="scss">
</style>